import React, {useEffect, useState} from "react";
import moment from "moment";
import ReactApexChart from "react-apexcharts";
import Loading from "../../../components/Loading/LoadingEffect";
import {getLottoGraphData} from "../../../controllers/V1/statisticsReports/statisticsReportsController";
const Recent_order = () => {
  const [isLoading, setIsLoading]= useState(false);
  const [graphDate, setgraphDate] = useState(moment().format('YYYY-MM-DD'))
  const [totalSales, setTotalSales] = useState(0);
  const [graphType, setGraphType] = useState('bar');

  const [hour, setHour] = useState([]);
  const [count, setCount] = useState([]);

  const getData = async () => {
    setIsLoading(true);
    try {
      const option = {
        date : graphDate
      }
      const res = await getLottoGraphData(option);
      if (res.status === true) {
        if (res.result?.length > 0) {
          let points = 0;
          const hours = [], counts = [], totalSales = [];

          res.result.forEach(item => {
            // Format time range
            const formattedTime = `${moment(`2025-02-23 ${item._id}:00:00`).add(3, 'hours').format('hh A')} to 
                                  ${moment(`2025-02-23 ${item._id}:00:00`).add(4, 'hours').format('hh A')}`;
            hours.push(formattedTime);
            counts.push(item.count);
            const itemPoints = parseFloat(item.total_points) || 0;
            points = itemPoints + points; 
            totalSales.push(points); 
          });

          setHour(hours);
          setCount(counts);
          setTotalSales(points);
        } else {
          setHour(['No order found!']);
          setCount([0]);
          setTotalSales([0]);  
        }
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setHour(['No order found!']);
      setCount([0]);
      setTotalSales([0]);  
    }
  }

  const handleDateChnage = (e)=>{
    setgraphDate(e.target.value);
  }

  useEffect(()=>{
    getData();
  },[graphDate])


  const series = [
    {
      name: "Sales",
      data: count
      // data: graphData[showGraph],
    },
  ];
  const options = {
    chart: {
      height: 350,
      type: graphType,
    },
    xaxis: {
      categories: hour,
    },
  };
  return (
    <>
      <div className="inventory_tabs_main_div mt-0">
        <div className="card ">
          <div className="card-header all_border_bottom_for_hide">
            <div className="d-flex justify-content-between align-items-center">
              <h5 className="card-title mb-0">Lotto Orders</h5>
              <div className="card-title mb-0">
                <select onChange={(e)=>setGraphType(e.target.value)} className="form-control select_filter_class">
                  <option value={'bar'} >Bricks</option>
                  <option value={'area'}>Wave</option>
                </select>
                </div>
                <div className="card-title mb-0">
                <input type="date" name="date" id="date" value={graphDate} onChange={handleDateChnage} className="form-control select_filter_class" />
              </div>
            </div>
          </div>
          <div className="card-body">
            <div>
              <ReactApexChart
                options={options}
                series={series}
                type={graphType}
                height={350}
              />
            </div>
            
          </div>
          <div className="card-header all_border_bottom_for_hide">
            <div className="d-flex justify-content-between align-items-center">
              <button type="button" onClick={()=>setgraphDate(moment(graphDate).subtract(1, 'days').format('YYYY-MM-DD'))} className="btn btn-light card-title mb-0">{`<< Pre`}</button>
              <div className="card-title mb-0">
                  <h5>Total Sales : {totalSales}</h5>
              </div>
              <div className="card-title mb-0">
                <button type="button" onClick={()=>setgraphDate(moment(graphDate).add(1, 'days').format('YYYY-MM-DD'))} className="form-control card-title mb-0">{`Next >>`}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Loading isLoading={isLoading} />
    </>
  );
}

export default Recent_order;
